import React from 'react';
import { alpha, Box, Theme } from '@mui/material';
import IconMi from 'components/common/icon/IconMi';
import { IGlossaryTermStatus } from 'api/editor/topics';
import { useAppSelector } from 'store/hooks';
import { IGlossarySettings } from 'store/auth';
import { SxProps } from '@mui/system/styleFunctionSx';

interface GlossaryTermStatusProps {
    status?: IGlossaryTermStatus;
    sx?: SxProps<Theme>;
}

export default function GlossaryTermStatus(props: GlossaryTermStatusProps) {
    const { status, sx } = props;
    const glossarySettings: IGlossarySettings | undefined = useAppSelector(
        (state) => state.auth?.configuration?.glossarySettings,
    );

    if (!glossarySettings?.use_statuses || !glossarySettings?.show_status_label || !status?.name) return null;

    return (
        <Box
            sx={{
                ...{
                    fontSize: (theme) => theme.size.pxValue(theme.typography.fontSize),
                    fontWeight: 400,
                    display: 'inline-flex',
                    borderRadius: '3px',
                    p: '1px 4px',
                    backgroundColor: status?.color ? alpha(status.color, 0.08) : undefined,
                    color: status?.color ?? undefined,
                    maxWidth: '100%',
                },
                ...(sx ?? {}),
            }}
        >
            {status?.icon && <IconMi icon={status.icon} sx={{ fontSize: '16px', mr: '6px', mt: '1px' }} />}
            <Box sx={{ minWidth: 0, wordWrap: 'break-word' }}>{status?.name ?? ''}</Box>
        </Box>
    );
}
